import {TooltipModel} from "./tooltip.model";

export class OnBoardingTooltipModel extends TooltipModel {

    // I, Mircea Ulmeanu, copied this display getter to onboarding-tour.service.ts difference is this one counts all overlay consumers except himself.
    // That's why that one `display` method will return true after this one (on-boarding-tooltip.model.ts).
    // But because those two cases are particular and specific I choose not to extract this method in a more generic one.
    get display(): boolean {

        const orbitOverlayConsumersCount = this.services.overlay.countCurrentConsumers(consumer => {
            if(consumer === this.tooltipService) {
                return false;
            }

            return consumer.needsOverlay;
        });

        const sdkHasOpenOverlays = this.services.sdk.hasOpenOverlays;
        const areRunningApps = this.services.appLauncher.isThereRunningApps;
        const areOpenDialogs = this.services.dialog.hasOpenDialogs;

        //The reason we put the values in those variables is to make sure that this display getter depends on all these observables.

        return !(sdkHasOpenOverlays
            || areRunningApps
            || areOpenDialogs
            || orbitOverlayConsumersCount > 0);
    }
}